import { type ReactNode } from 'react';
import classNames from 'classnames';
import { Button } from '@fff-web/fff-ui-shared';
import { CouponCodeField, type CouponCodeFieldPropsType } from '../../components/CouponCodeField';
import { BestValueContainer } from './components/BestValueContainer';
import HeroBanner from './components/HeroBanner/HeroBanner';
import { OneMillionContainer } from './components/OneMillionContainer';
import TermsAndConditions from './components/TermsAndConditions';
import * as styles from './UpgradeRedesign.module.scss';

const SUBMIT_CTA_NAME = 'YES, UPGRADE ME!';

interface BaseUpgradePageProps {
  onSubmitSubscription: () => void;
  getCouponContentKey: (key: string, defaultValue: string) => string;
  hCaptcha: ReactNode;
  couponProps: CouponCodeFieldPropsType;
  isLoading: boolean;
}

const UpgradeRedesign = ({
  onSubmitSubscription,
  isLoading,
  couponProps,
  hCaptcha,
}: BaseUpgradePageProps) => {
  return (
    <main className={styles.upgradeWrapper}>
      <HeroBanner />
      <div className={styles.upgradeContainer}>
        <BestValueContainer />
        <section className={styles.couponCodeWrapper}>
          <CouponCodeField {...couponProps} />
        </section>
        <TermsAndConditions />
        <section className={styles.ctaSectionWrapper}>
          <Button disabled={isLoading} onClick={onSubmitSubscription}>
            {SUBMIT_CTA_NAME}
            {hCaptcha}
          </Button>
        </section>
        <OneMillionContainer />
        <section className={classNames(styles.ctaSectionWrapper, styles.footerCta)}>
          <Button disabled={isLoading} onClick={onSubmitSubscription}>
            {SUBMIT_CTA_NAME}
            {hCaptcha}
          </Button>
        </section>
      </div>
    </main>
  );
};

export { UpgradeRedesign };
export type { BaseUpgradePageProps };
